/**
 * 컬렉션 이름 규칙 (FN-033 · FN-035 · SC-013, 2026-08-28 확정).
 *
 *   · 1~20자 — 공백 포함, 앞뒤 공백은 저장할 때 제거, 공백만은 불가
 *   · 21자째부터 **입력 자체를 막는다** + 글자 수 카운터 n/20
 *   · 중복 허용 — 같은 이름의 컬렉션이 여러 개일 수 있다 (구분은 사용자 몫)
 *
 * ⚠ "이모지 1개 = 1자" 다. JS 의 `.length` 는 UTF-16 단위라 🔥 가 2, 👨‍👩‍👧 가 8 로
 *   세어져 20자 규칙이 이모지 하나로 흔들린다. 그래서 `Intl.Segmenter` 로
 *   **눈에 보이는 글자(grapheme)** 단위로 센다. 한글 완성형은 어느 쪽이든 1 이다.
 *   (Capacitor 웹뷰 · 최신 Safari/Chrome 모두 지원. 없으면 코드 포인트로 물러선다.)
 */
export const COLLECTION_NAME_MAX = 20;

const segmenter =
  typeof Intl !== "undefined" && "Segmenter" in Intl
    ? new Intl.Segmenter("ko", { granularity: "grapheme" })
    : null;

function graphemes(value: string): string[] {
  if (segmenter) return Array.from(segmenter.segment(value), (s) => s.segment);
  return Array.from(value);
}

/** 보이는 글자 수 — 카운터 `n/20` 에 쓴다. */
export function collectionNameLength(value: string): number {
  return graphemes(value).length;
}

/** 입력 중 21자째부터 잘라 낸다 (onChange 에서 호출). 앞뒤 공백은 여기서 건드리지 않는다 —
 *  "이브이 파생 " 처럼 띄어쓰기 중간 상태를 막으면 안 된다. 제거는 저장 시점(trim)에. */
export function clampCollectionName(value: string): string {
  const g = graphemes(value);
  return g.length <= COLLECTION_NAME_MAX ? value : g.slice(0, COLLECTION_NAME_MAX).join("");
}

/** 저장 가능한가 — 앞뒤 공백을 뺀 뒤 1자 이상. */
export function canSubmitCollectionName(value: string): boolean {
  return value.trim().length > 0;
}
